export default { sha: '8ed0c57bd81498c4383219d00dfe556b3a62e039', buildNumber: 'undefined' }
